import { produce } from 'immer';
import localStorageKeys from 'constants/localStorageKeys';
import * as types from './userTypes';
import createReducer from '../utils/createReducer';

const initialState = {
    userBasicDetails: {
        firstName: '',
        lastName: '',
        photoURL: '',
    },
    authenticated: !!localStorage.getItem(localStorageKeys.ACCESS_TOKEN),
    tokenData: undefined,
    userData: localStorage.getItem(localStorageKeys.USER_DATA)
        ? JSON.parse(localStorage.getItem(localStorageKeys.USER_DATA))
        : '',
    isPerformLogoutAction: false,
    role: localStorage.getItem(localStorageKeys.ROLE) || '',
};

const actionHandlers = {
    [types.LOGIN.REQUEST]: produce((draft) => {
        localStorage.removeItem(localStorageKeys.ACCESS_TOKEN);
        localStorage.removeItem(localStorageKeys.ROLE);
        localStorage.removeItem(localStorageKeys.USERID);
        localStorage.removeItem(localStorageKeys.USER_DATA);
        localStorage.removeItem(localStorageKeys.PARTICIPANT_VIEW);
        draft.authenticated = false;
        draft.tokenData = undefined;
        draft.userData = undefined;
    }),
    [types.LOGIN.SUCCESS]: produce((draft, { token, tokenData, role }) => {
        localStorage.setItem(localStorageKeys.ACCESS_TOKEN, token);
        localStorage.setItem(localStorageKeys.ROLE, role);
        localStorage.setItem(localStorageKeys.USERID, tokenData.userId);
        const data = {
            eventHubId: tokenData.eventHubId,
        };
        localStorage.setItem(localStorageKeys.USER_DATA, JSON.stringify(data));
        draft.authenticated = true;
        draft.tokenData = tokenData;
        draft.userData = data;
        draft.role = role;
    }),
    [types.LOGIN.FAILURE]: produce((draft) => {
        localStorage.removeItem(localStorageKeys.ACCESS_TOKEN);
        localStorage.removeItem(localStorageKeys.ROLE);
        localStorage.removeItem(localStorageKeys.USERID);
        localStorage.removeItem(localStorageKeys.USER_DATA);
        localStorage.removeItem(localStorageKeys.PARTICIPANT_VIEW);
        draft.authenticated = false;
        draft.tokenData = undefined;
        draft.userData = undefined;
        draft.role = '';
    }),
    [types.LOGOUT]: produce((draft) => {
        localStorage.removeItem(localStorageKeys.ACCESS_TOKEN);
        localStorage.removeItem(localStorageKeys.ROLE);
        localStorage.removeItem(localStorageKeys.USERID);
        localStorage.removeItem(localStorageKeys.USER_DATA);
        localStorage.removeItem(localStorageKeys.PARTICIPANT_VIEW);
        draft.authenticated = false;
        draft.tokenData = undefined;
        draft.userData = undefined;
        draft.userBasicDetails = undefined;
        draft.role = '';
    }),
    [types.UPDATE_USER_DETAILS]: produce((draft, { data }) => {
        draft.userBasicDetails = data;
    }),
    [types.UPDATE_LOGOUT_PERFORM_STATE]: produce(
        (draft, { isLogoutAction }) => {
            draft.isPerformLogoutAction = isLogoutAction;
        }
    ),
    [types.UPDATE_USER_ROLE]: produce((draft, { role }) => {
        localStorage.setItem(localStorageKeys.ROLE, role);
        draft.role = role;
    }),
};

export default createReducer(initialState, actionHandlers);
